import API from '../../../../services/apiService.js'

var api= new API();


export default {

  // Загрузить данные по штрафам
  async loadFines ({ commit }) {
    var data=null;
    try{
      data = await api.Get("InformationService/Fine");
      commit('loafFines', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },


  //добавить штраф
  async addFine({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      newId = await api.Post("InformationService/Fine", data);
      if (newId != null) {
        var getparams = '?Id=' + newId.id;
        newData = await api.Get("InformationService/Fine/GetById" + getparams)
      }
      if (newData != null && newData != "")
        commit('addFine', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //редактировать штраф
  async editFine({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      await api.Put("InformationService/Fine", data);
      var getparams = '?Id=' + data.id;
      newData = await api.Get("InformationService/Fine/GetById" + getparams)

      if (newData != null && newData != "")
        commit('editFine', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //удалить штраф
  async deleteFine({commit}, fineId) {
    try {
      var getparams = '?FineId=' + fineId;
      await api.Delete("InformationService/Fine", getparams);
      commit('deleteFine',fineId);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },


}
